import { useEffect, useRef, useState } from "react";
import Sidebar from "../common/Sidebar";
import "../customCss/AllUsers.css";
import DataService from "../services/data.service";
import LoadingBar from "react-top-loading-bar";
import { toast } from "react-toastify";
import Logout from "../common/Logout";
import moment from "moment";

const WinterCampBookings = () => {
    const ref = useRef(null);
    const [loading, setLoading] = useState(false);
    const [bookings, setBookings] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [searchName, setSearchName] = useState("");
    const [searchDate, setSearchDate] = useState("");

    const getAllBookings = async () => {
        setLoading(true);
        ref.current.continuousStart();
        try {
            const res = await DataService.getAllWinterCampBookings();
            const data = res?.data?.data?.reverse() || [];
            setBookings(data);
            setFiltered(data);
        } catch (error) {
            console.error(error);
            toast.error("Failed to load bookings");
        } finally {
            setLoading(false);
            ref.current.complete();
        }
    };

    const filterBookings = () => {
        const filteredData = bookings.filter((b) => {
            const nameMatch = b?.parentName
                ?.toLowerCase()
                ?.includes(searchName.toLowerCase());
            const dateMatch =
                !searchDate ||
                b?.bookingDate?.startsWith(searchDate) ||
                b?.multipleDates?.includes(searchDate);
            return nameMatch && dateMatch;
        });
        setFiltered(filteredData);
    };

    useEffect(() => {
        document.title = "Winter Camp Bookings";
        getAllBookings();
    }, []);

    useEffect(() => {
        filterBookings();
    }, [searchName, searchDate]);

    return (
        <div className="main_section">
            <div className="main_flex">
                <div className="main_flexL">
                    <Sidebar />
                </div>
                <div className="main_flexR">
                    <div className="right_title">
                        <h1>Winter Camp Bookings</h1>
                        <Logout />
                    </div>

                    <LoadingBar color="#84C342" ref={ref} height={5} />
                    <div className="filters_sec">
                        <div className="filtersL">
                            <div className="row">
                                <div className="col-sm-3">
                                    <div className="form-floating mb-3">
                                        <input
                                            type="text"
                                            placeholder="Search by Parent Name"
                                            value={searchName}
                                            className="form-control"
                                            id="floatingInputParent"
                                            onChange={(e) => setSearchName(e.target.value)}
                                        />
                                        <label for="floatingInputParent">
                                            Search by Parent Name
                                        </label>
                                    </div>
                                </div>
                                <div className="col-sm-3">
                                    <div className="form-floating mb-3">
                                        <input
                                            type="date"
                                            value={searchDate}
                                            placeholder="Booking Date"
                                            className="form-control"
                                            id="floatingInputParent"
                                            onChange={(e) => setSearchDate(e.target.value)}
                                        />
                                        <label for="floatingInputDate">Booking Date</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="filtersR text-end">
                            <button
                                id="reloadBtn"
                                onClick={() => getAllBookings()}
                                disabled={loading}
                            >
                                <i
                                    className={`fa fa-sync-alt ${loading ? "fa-spin" : ""}`}
                                    id="reloadIcon"
                                ></i>{" "}
                                Reload
                            </button>
                        </div>
                    </div>

                    <div className="main_innerSec">
                        <div className="main_booksSec">
                            <table className="table table-striped table-bordered">
                                <thead>
                                    <tr style={{ background: "#f5f5f5" }}>
                                        <th>S. No.</th>
                                        <th>Parent Name</th>
                                        <th>Phone</th>
                                        <th>Email</th>
                                        <th>Child Name</th>
                                        <th>Child Age</th>
                                        <th>Address</th>
                                        <th>20% Discount ?</th>
                                        <th>Age Group</th>
                                        <th>Day Type</th>
                                        <th>Day Duration</th>
                                        <th>Booking Date</th>
                                        <th>Multiple Dates</th>
                                        <th>Lunch Included ?</th>
                                        <th>Late Pickup Fee ?</th>
                                        <th>Enrollment Fee ?</th>
                                        <th>Coupon Applied ?</th>
                                        <th>Coupon Amount</th>
                                        <th>Amount Paid</th>
                                        <th>Payment Status</th>
                                        <th>Created At</th>
                                    </tr>
                                </thead>
                                <tbody id="wevillage-booking-tbody">
                                    {loading ? (
                                        <tr>
                                            <td colSpan="15">Loading bookings...</td>
                                        </tr>
                                    ) : filtered?.length > 0 ? (
                                        filtered.map((booking, index) => (
                                            <tr
                                                key={index}
                                                style={{ borderBottom: "1px solid #ddd" }}
                                            >
                                                <td>{index + 1}</td>
                                                <td>{booking?.parentName || "-"}</td>
                                                <td>{booking?.parentNumber || "-"}</td>
                                                <td>{booking?.parentEmail || "-"}</td>
                                                <td>{booking?.childName || "-"}</td>
                                                <td>{booking?.childAge || "-"}</td>
                                                <td>{booking?.address || "-"}</td>
                                                <td className="text-center">
                                                    {booking?.promoApplied ? "Yes" : "No"}
                                                </td>
                                                <td>{booking?.ageGroup || "-"}</td>
                                                <td>{booking?.dayType || "-"}</td>
                                                <td>{booking?.dayDuration || "-"}</td>
                                                <td>
                                                    {booking?.bookingDate
                                                        ? moment(booking.bookingDate).format("DD MMM YYYY")
                                                        : "-"}
                                                </td>
                                                <td>
                                                    {booking?.multipleDates?.length
                                                        ? booking.multipleDates
                                                            .map((d) => moment(d).format("DD MMM YYYY"))
                                                            .join(", ")
                                                        : "-"}
                                                </td>
                                                <td className="text-center">
                                                    {booking?.includeLunch ? "Yes" : "No"}
                                                </td>
                                                <td className="text-center">
                                                    {booking?.includeLatePickup ? "Yes" : "No"}
                                                </td>
                                                <td className="text-center">
                                                    {booking?.existingParentFee ? "Yes" : "No"}
                                                </td>
                                                <td className="text-center">
                                                    {booking?.couponApplied ? "Yes" : "No"}
                                                </td>
                                                <td className="text-center">
                                                    {booking?.couponAmount ? `$${booking.couponAmount}` : "-"}
                                                </td>
                                                <td className="text-center">
                                                    {booking?.price ? `$${booking.price}` : "-"}
                                                </td>
                                                <td>{booking?.paymentStatus || "-"}</td>
                                                <td>
                                                    {moment(booking?.createdAt).format(
                                                        "MM/DD/YYYY hh:mm A"
                                                    )}
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="15">No bookings found.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WinterCampBookings;
